angular.module('subscriptionProductAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/subscription-product-add/subscription-product-add.module.js